export default "__VITE_ASSET__DKHU4QrF__"